import React from "react";

export default class InputForm extends React.Component {
  constructor(props) {
    super(props);

    //Initial
    let data = props.data || {};
    let fields = props.fields || {};

    //Set defaults
    for (let fieldId in fields) {
      fields[fieldId].value = data[fieldId] || fields[fieldId].default;
    }

    this.state = { fields, data };
  }

  submit = () => {
    let errors = false;
    let values = {};
    let fields = this.state.fields;
    for (let fieldId in fields) {
      let field = fields[fieldId];
      if (field.type === "check") field.value = field.value ? true : false;
      values[fieldId] = field.value;
      fields[fieldId].error = false;
      if (field.validate) {
        if (field.validate === true) {
          if (!field.value) {
            fields[fieldId].error = "Это поле обязательно для заполнения";
            errors = true;
          }
        }
      }
    }
    if (errors) {
      this.setState({ fields });
    } else {
      this.setState({ fields });
      this.props.onSubmit(values);
    }
  };

  inputChange = (id, value) => {
    this.setState((state) => {
      let fields = state.fields;
      fields[id].value = value;
      fields[id].error = false;
      return { fields };
    });
  };

  inputRender = (fieldId) => {
    let field = this.state.fields[fieldId] || {};
    let col = field["col"] || "12";

    if (field.type === "check")
      return (
        <div key={fieldId} className={`form-group col-lg-${col}`}>
          <label className="checkbox">
            <input
              id={fieldId}
              onChange={(e) => this.inputChange(e.target.id, e.target.checked)}
              checked={field.value ? true : false}
              type="checkbox"
              key={fieldId}
            />
            <span className="mr-4"></span>
            {field.title}
          </label>

          {field.error ? (
            <div className="font-italic text-danger font-size-sm">
              {field.error}
            </div>
          ) : null}
        </div>
      );

    if (field.type === "text")
      return (
        <div key={fieldId} className={`form-group col-lg-${col}`}>
          <label>{field.title}</label>
          <input
            id={fieldId}
            onChange={(e) => this.inputChange(e.target.id, e.target.value)}
            value={field.value}
            type="text"
            className={`form-control ${field.error ? "invalid" : ""}`}
            key={fieldId}
          />
          {field.error ? (
            <div className="font-italic text-danger font-size-sm">
              {field.error}
            </div>
          ) : null}
        </div>
      );

    if (field.type === "select")
      return (
        <div key={fieldId} className={`form-group col-lg-${col}`}>
          <label>{field.title}</label>
          <select
            id={fieldId}
            onChange={(e) => this.inputChange(e.target.id, e.target.value)}
            value={field.value}
            className={`form-control ${field.error ? "invalid" : ""}`}
            key={fieldId}
          >
            <option></option>
            {Object.entries(field.values).map(([id, item]) => (
              <option value={item.id} key={id}>
                {" . . ".repeat(item.level)} {item[field.valuesNameKey]}
              </option>
            ))}
          </select>
          {field.error ? (
            <div className="font-italic text-danger font-size-sm">
              {field.error}
            </div>
          ) : null}
        </div>
      );
  };

  render() {
    return (
      <>
        <div className="row">
          {Object.entries(this.state.fields).map(([fieldId]) =>
            this.inputRender(fieldId)
          )}
        </div>
        <div className="form-group">
          {this.props.onSubmit ? (
            <button className="btn btn-primary mr-2" onClick={this.submit}>
              Сохранить
            </button>
          ) : null}
          {this.props.onCancell ? (
            <button
              className="btn btn-light mr-2"
              onClick={this.props.onCancell}
            >
              Отмена
            </button>
          ) : null}
        </div>
      </>
    );
  }
}
